import Vue from 'vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import SsrCarousel from 'vue-ssr-carousel'

Vue.component('SsrCarousel', SsrCarousel)

Vue.use(VueSlickCarousel)

// If you don't need the styles, do not connect

Vue.use(VueSweetalert2)
